import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Signal1973xs1vkmdcb as Signal,
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  hasConcernCard3nodxgigqanyg as hasConcernCard,
  Type_LineItem_getInstanceq184uyry7c2 as Type_LineItem_getInstance,
  ConcernCardInfo27c6vqv7qq44u as ConcernCardInfo,
  Type_Incident_getInstance3i10g3y530893 as Type_Incident_getInstance,
} from './ConcernCardInfo.mjs';
import {
  plus310ted5e4i90h as plus,
  sortDescending17f1fftsbt2oe as sortDescending,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  first58ocm7j58k3q as first,
  sortedWith2csnbbb21k0lg as sortedWith,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  RowCollapsingToColumn13iucsgmjquhb as RowCollapsingToColumn,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  dismissableBanner3s49vuosvr23r as dismissableBanner,
  notificationBar4efejtg2792g as notificationBar,
} from '../../../../theming/banners.mjs';
import { ProjectLens_Customer_getInstancedmuwwz4nvrem as ProjectLens_Customer_getInstance } from '../../../../screens/common/ProjectView.mjs';
import {
  get_expanding10cuv3ua9vajx as get_expanding,
  get_centered1xfu6or5nc0lq as get_centered,
  get_atTopEnd21ub47e8cwtv6 as get_atTopEnd,
  forEach37zw770vd3h4l as forEach,
  get_atEnd1cw5d2zgug26 as get_atEnd,
  get_atBottomzb604i67rgu3 as get_atBottom,
  forEachUpdating2xo34s2yjc7ia as forEachUpdating,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../../nav/AppDimensions.mjs';
import {
  Dimensions32ju1l7z4mh as Dimension,
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance,
  timesx4ey3un7ihw1 as times,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  listOfvhqybd2zx248 as listOf,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  get_compact3lsezez8nz8b6 as get_compact,
  dynamicThemexp3sdnaolntz as dynamicTheme,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  resize3py5p2yrjp6p7 as resize,
  shownDefaultFalse3hpz4awymyomc as shownDefaultFalse,
  filterNullKeys1r8wmaox0efdd as filterNullKeys,
  awaitSuspendingfmims6z9kmaq as awaitSuspending,
} from '../../../../../utils/utils.mjs';
import { icon1sxjaie5w1apt as icon } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import {
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_unpadded3gipn3ftxgnwh as get_unpadded,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  get_viewIsWide3s4g60a9e0192 as get_viewIsWide,
  get_viewIsNarrow26l63sh4olw2h as get_viewIsNarrow,
  get_dialogStackleaqvayyucjw as get_dialogStack,
  navigateOrDialog1m0cnx3luzasq as navigateOrDialog,
} from '../../../nav/crowpay.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import {
  ReportIncidentButton_getInstance34farqsakvpxm as ReportIncidentButton_getInstance,
  ConcernCard_getInstance1gv23vco4jz4i as ConcernCard_getInstance,
} from '../../../../theming/formThemes.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import {
  canFileIncidents2jxv4kkqx5ug0 as canFileIncidents,
  displayState3v4rl6ol8mfdu as displayState,
  displayState2k8glkzyt1ny6 as displayState_0,
  isFinal1ds8cwv2a0e8r as isFinal,
} from '../../../../../../../../crowpay-shared/com/crowpay/statePermissions.mjs';
import { specCenteredText1zemopd0g3rsf as specCenteredText } from '../../../../theming/buttons.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  concernsLegendInfoBubble92oj457wdret as concernsLegendInfoBubble,
  actionIcon360epyywhabwj as actionIcon,
  escalationIconmtio0lqe8r8o as escalationIcon,
  timerRunningIconRawxi2umccveawo as timerRunningIconRaw,
  TimerState_Running_getInstance2chni4wrq2yl4 as TimerState_Running_getInstance,
  TimerState_Paused_getInstance1wqc2dmfswf7h as TimerState_Paused_getInstance,
  TimerState_Cancelled_getInstance1atp9q6dwcp0z as TimerState_Cancelled_getInstance,
} from '../../../iconShortcuts.mjs';
import { shownWhenxgf1ujy6rmvr as shownWhen } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  NothingHereSemantic_getInstance3tro8v94k1jgs as NothingHereSemantic_getInstance,
  OverlayHover_getInstances85cpyxi08dm as OverlayHover_getInstance,
} from '../../../../theming/appTheme.mjs';
import {
  title1ahgushtajx2d as title,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
  SmallBodySemantic_getInstance13vsg4635cu56 as SmallBodySemantic_getInstance,
  BoldSemantic_getInstance3sy4hmow8wwn9 as BoldSemantic_getInstance,
  body3i5t0n7zprpqb as body,
} from '../../../../theming/Titles.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  _ReactiveState___get_raw__impl__92ipya10f5f3x6hwqt0 as _ReactiveState___get_raw__impl__92ipya,
  InternalReactiveNotReadygki7zhqkkp9u as InternalReactiveNotReady,
} from '../../../../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { ActivityIndicatork1oa7i2hevyv as ActivityIndicator } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ActivityIndicator.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { HalfGap_getInstance2pfkgmm8af0gl as HalfGap_getInstance } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/forEachReorderable.mjs';
import {
  Formats_getInstance5hp5sczkglnx as Formats_getInstance,
  format1crnfsffhjur0 as format,
} from '../../../../../../../../crowpay-shared/com/crowpay/timeFormatting.mjs';
import { DisplayableStateSemantic2q119ycceacla as DisplayableStateSemantic } from '../../../../theming/states.mjs';
import { MessageSemantic26vy91vxbjwf0 as MessageSemantic } from '../../../../theming/sections.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../../../../sdk/UserSession.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { TimerAction_CompleteLineItem_getInstance3bxbacatbrybs as TimerAction_CompleteLineItem_getInstance } from '../../../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { NotFoundikk4a5uq9edp as NotFound } from '../../../../../sdk/errors.mjs';
import {
  LineItemCompletionMessage2zpi6q6jke1no as LineItemCompletionMessage,
  IncidentMessage1zg9aeg4hgwtu as IncidentMessage,
  ChangeRequesthd3ysa2j1i4f as ChangeRequest,
} from '../../../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { LineItemHistory34tsqqs4wiqdw as LineItemHistory } from '../../../../../../../../crowpay-shared/com/crowpay/completionResponse/CompletionFlowPermissions.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { readByIntersection2rlpnb08zldsj as readByIntersection } from '../../../../../extensions/HasReadBy.ext.mjs';
import { requiresAction13nb01xm2r5gu as requiresAction } from '../../../../../extensions/FlowPermissions.ext.mjs';
import { EscalationLevel_Disputed_getInstance3pwh4crkd38ie as EscalationLevel_Disputed_getInstance } from '../../../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { IncidentHistory100uyzm3w697n as IncidentHistory } from '../../../../../../../../crowpay-shared/com/crowpay/incidentResponse/IncidentFlowPermissions.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { NoSuchElementException679xzhnp5bpj as NoSuchElementException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Companion_getInstance3vjikuur3h0k4 as Companion_getInstance_0 } from '../../../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../../../theming/AppColors.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { FileIncidentConfirmation1hq6dfo832450 as FileIncidentConfirmation } from '../../../../dialogs/FileIncidentConfirmation.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { StateTagSemanticqbegmxb4xh2t as StateTagSemantic } from './tags.mjs';
import { Companion_instance3euo5q27joywz as Companion_instance } from '../../work/scope/LineItemCompletionForm.mjs';
import { set_value1vvx5pkb20ebv as set_value } from '../../../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { Companion_instance2o1tmep3w0ant as Companion_instance_0 } from './IncidentReportForm.mjs';
import {
  DrawWaitedDetails301fxrq4n3zo5 as DrawWaitedDetails,
  ChangesRejectedDetails1h1y23it63u9u as ChangesRejectedDetails,
} from '../../../../dialogs/BasicFlowForms.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ConcernSection_All_instance;
var ConcernSection_Work_instance;
var ConcernSection_Service_instance;
var ConcernSection_Draws_instance;
var ConcernSection_Changes_instance;
function values() {
  return [ConcernSection_All_getInstance(), ConcernSection_Work_getInstance(), ConcernSection_Service_getInstance(), ConcernSection_Draws_getInstance(), ConcernSection_Changes_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var ConcernSection_entriesInitialized;
function ConcernSection_initEntries() {
  if (ConcernSection_entriesInitialized)
    return Unit_instance;
  ConcernSection_entriesInitialized = true;
  ConcernSection_All_instance = ConcernSection().agt('All', 0, 'All');
  ConcernSection_Work_instance = ConcernSection().agt('Work', 1, 'Work');
  ConcernSection_Service_instance = ConcernSection().agt('Service', 2, 'Service');
  ConcernSection_Draws_instance = ConcernSection().agt('Draws', 3, 'Draws');
  ConcernSection_Changes_instance = ConcernSection().agt('Changes', 4, 'Changes');
}
var $ENTRIES;
var ConcernSectionClass;
function ConcernSection() {
  if (ConcernSectionClass === VOID) {
    class $ extends Enum() {
      static agt(name, ordinal, displayName) {
        var $this = this.c4(name, ordinal);
        $this.zgs_1 = displayName;
        return $this;
      }
    }
    initMetadataForClass($, 'ConcernSection');
    ConcernSectionClass = $;
  }
  return ConcernSectionClass;
}
function concerns(_this__u8e3s4, writer) {
  // Inline function 'kotlin.with' call
  var selectedSection = Signal().fak(ConcernSection_All_getInstance());
  var tmp = _this__u8e3s4.ngf();
  var lineTimers = lens(tmp, concerns$lambda);
  var tmp_0 = _this__u8e3s4.bgt();
  var lineItemMessages = lens(tmp_0, concerns$lambda_0);
  var tmp_1 = _this__u8e3s4.cgt();
  var incidentMessages = lens(tmp_1, concerns$lambda_1);
  var tmp_2 = _this__u8e3s4.dgt();
  var payApps = lens(tmp_2, concerns$lambda_2);
  var tmp_3 = _this__u8e3s4.tgm();
  var lineItems = lens(tmp_3, concerns$lambda_3);
  var concernCards = remember(VOID, VOID, VOID, ($this$remember) => {
    var cards = ArrayList().w();
    var lineItemMessages_0 = $this$remember.baj(lineItemMessages);
    var incidentMessages_0 = $this$remember.baj(incidentMessages);
    var lineComments = $this$remember.baj(_this__u8e3s4.egt());
    var incidentComments = $this$remember.baj(_this__u8e3s4.fgt());
    var payApps_0 = $this$remember.baj(payApps);
    var lineItems_0 = $this$remember.baj(lineItems);
    switch ($this$remember.baj(selectedSection).b4_1) {
      case 0:
        // Inline function 'kotlin.collections.filter' call

        var tmp0 = lineItems_0.r3();
        // Inline function 'kotlin.collections.filterTo' call

        var destination = ArrayList().w();
        var _iterator__ex2g4s = tmp0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          var tmp$ret$0;
          $l$block: {
            var tmp0_elvis_lhs = lineItemMessages_0.p3(element.kf9_1);
            var tmp;
            if (tmp0_elvis_lhs == null) {
              tmp$ret$0 = false;
              break $l$block;
            } else {
              tmp = tmp0_elvis_lhs;
            }
            tmp$ret$0 = hasConcernCard(element, tmp);
          }
          if (tmp$ret$0) {
            destination.v(element);
          }
        }

        concerns$_anonymous_$_anonymous_$getCards_7kfjf0(destination, cards, lineItemMessages_0, $this$remember, _this__u8e3s4, lineTimers, lineComments);
        concerns$_anonymous_$_anonymous_$getCards$0_r9bqu0($this$remember.baj(_this__u8e3s4.ggt()), cards, incidentMessages_0, $this$remember, _this__u8e3s4, incidentComments);
        // Inline function 'kotlin.collections.filter' call

        var tmp0_0 = $this$remember.baj(_this__u8e3s4.hgt());
        // Inline function 'kotlin.collections.filterTo' call

        var destination_0 = ArrayList().w();
        var _iterator__ex2g4s_0 = tmp0_0.m1();
        while (_iterator__ex2g4s_0.n1()) {
          var element_0 = _iterator__ex2g4s_0.o1();
          if (!(element_0.v6v_1 == null)) {
            destination_0.v(element_0);
          }
        }

        concerns$_anonymous_$_anonymous_$getCards$1_r9bqu1(destination_0, cards, payApps_0, lineItems_0, _this__u8e3s4);
        // Inline function 'kotlin.collections.filter' call

        var tmp0_1 = plus($this$remember.baj(_this__u8e3s4.igt()), $this$remember.baj(_this__u8e3s4.jgt()));
        // Inline function 'kotlin.collections.filterTo' call

        var destination_1 = ArrayList().w();
        var _iterator__ex2g4s_1 = tmp0_1.m1();
        while (_iterator__ex2g4s_1.n1()) {
          var element_1 = _iterator__ex2g4s_1.o1();
          if (!(element_1.y94() == null)) {
            destination_1.v(element_1);
          }
        }

        concerns$_anonymous_$_anonymous_$getCards$2_r9bqu2(destination_1, cards, _this__u8e3s4);
        break;
      case 1:
        // Inline function 'kotlin.collections.filter' call

        var tmp0_2 = lineItems_0.r3();
        // Inline function 'kotlin.collections.filterTo' call

        var destination_2 = ArrayList().w();
        var _iterator__ex2g4s_2 = tmp0_2.m1();
        while (_iterator__ex2g4s_2.n1()) {
          var element_2 = _iterator__ex2g4s_2.o1();
          var tmp$ret$9;
          $l$block_0: {
            var tmp0_elvis_lhs_0 = lineItemMessages_0.p3(element_2.kf9_1);
            var tmp_0;
            if (tmp0_elvis_lhs_0 == null) {
              tmp$ret$9 = false;
              break $l$block_0;
            } else {
              tmp_0 = tmp0_elvis_lhs_0;
            }
            tmp$ret$9 = hasConcernCard(element_2, tmp_0);
          }
          if (tmp$ret$9) {
            destination_2.v(element_2);
          }
        }

        concerns$_anonymous_$_anonymous_$getCards_7kfjf0(destination_2, cards, lineItemMessages_0, $this$remember, _this__u8e3s4, lineTimers, lineComments);
        break;
      case 2:
        concerns$_anonymous_$_anonymous_$getCards$0_r9bqu0($this$remember.baj(_this__u8e3s4.ggt()), cards, incidentMessages_0, $this$remember, _this__u8e3s4, incidentComments);
        break;
      case 3:
        // Inline function 'kotlin.collections.filter' call

        var tmp0_3 = $this$remember.baj(_this__u8e3s4.hgt());
        // Inline function 'kotlin.collections.filterTo' call

        var destination_3 = ArrayList().w();
        var _iterator__ex2g4s_3 = tmp0_3.m1();
        while (_iterator__ex2g4s_3.n1()) {
          var element_3 = _iterator__ex2g4s_3.o1();
          if (!(element_3.v6v_1 == null)) {
            destination_3.v(element_3);
          }
        }

        concerns$_anonymous_$_anonymous_$getCards$1_r9bqu1(destination_3, cards, payApps_0, lineItems_0, _this__u8e3s4);
        break;
      case 4:
        // Inline function 'kotlin.collections.filter' call

        var tmp0_4 = plus($this$remember.baj(_this__u8e3s4.igt()), $this$remember.baj(_this__u8e3s4.jgt()));
        // Inline function 'kotlin.collections.filterTo' call

        var destination_4 = ArrayList().w();
        var _iterator__ex2g4s_4 = tmp0_4.m1();
        while (_iterator__ex2g4s_4.n1()) {
          var element_4 = _iterator__ex2g4s_4.o1();
          if (!(element_4.y94() == null)) {
            destination_4.v(element_4);
          }
        }

        concerns$_anonymous_$_anonymous_$getCards$2_r9bqu2(destination_4, cards, _this__u8e3s4);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    sortDescending(cards);
    return cards;
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(writer.pc());
  var tmp0_elvis_lhs = writer.cbb_1;
  var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
  writer.ebb(p, view);
  view.xbm(true);
  if (_this__u8e3s4.rgj().equals(ProjectLens_Customer_getInstance())) {
    dismissableBanner(view, 'concern tab info', concerns$lambda_4);
  }
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(false);
  var tmp_4 = get_expanding(view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
  var breakpoint = get_AppDimensions().gg2_1;
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowCollapsingToColumn())(view_0.pc(), listOf(new (Dimension())(breakpoint)));
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  var tmp_5 = get_compact(view_1);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp$ret$18 = view_1.hbb(FieldSemantic_getInstance());
  var tmp_6 = view_1.ibb(tmp_5, tmp$ret$18);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (RowOrCol())(view_1.pc());
  var tmp0_elvis_lhs_2 = view_1.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.ebb(p_2, view_2);
  view_2.xbm(false);
  view_2.jbb(get_centered(view_2), icon(view_2, resize(Companion_getInstance().lcg_1, get_rem(1)), 'filter'));
  var tmp_7 = get_viewIsWide(view_2) ? sizeConstraints(view_2, VOID, VOID, VOID, VOID, VOID, get_rem(10)) : get_expanding(view_2);
  // Inline function 'com.lightningkite.kiteui.views.direct.select' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (Select())(view_2.pc());
  var tmp0_elvis_lhs_3 = view_2.cbb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
  view_2.ebb(p_3, view_3);
  var tmp_8 = _Constant___init__impl__v45mub(get_entries());
  view_3.mcf(selectedSection, new (Constant())(tmp_8), concerns$lambda_5);
  view_2.fbb(p_3, view_3);
  view_2.jbb(tmp_7, view_3);
  view_1.fbb(p_2, view_2);
  view_1.jbb(tmp_6, view_2);
  if (_this__u8e3s4.rgj().equals(ProjectLens_Customer_getInstance())) {
    if (get_viewIsWide(view_1)) {
      var tmp_9 = get_expanding(view_1);
      // Inline function 'com.lightningkite.kiteui.views.direct.space' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_4 = new (Space())(view_1.pc());
      var tmp0_elvis_lhs_4 = view_1.cbb_1;
      var p_4 = tmp0_elvis_lhs_4 == null ? view_1 : tmp0_elvis_lhs_4;
      view_1.ebb(p_4, view_4);
      view_1.fbb(p_4, view_4);
      view_1.jbb(tmp_9, view_4);
    }
    var tmp_10 = view_1.hbb(ReportIncidentButton_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_5 = new (Button())(view_1.pc());
    var tmp0_elvis_lhs_5 = view_1.cbb_1;
    var p_5 = tmp0_elvis_lhs_5 == null ? view_1 : tmp0_elvis_lhs_5;
    view_1.ebb(p_5, view_5);
    shownDefaultFalse(view_5, ($this$shownDefaultFalse) => canFileIncidents($this$shownDefaultFalse.baj(_this__u8e3s4.jfy()).w7b_1));
    specCenteredText(view_5, 'Report Incident');
    onClick(view_5, VOID, VOID, concerns$slambda_0(_this__u8e3s4));
    view_1.fbb(p_5, view_5);
    view_1.jbb(tmp_10, view_5);
  }
  view_0.fbb(p_1, view_1);
  view_0.jbb(tmp_4, view_1);
  view_0.jbb(get_viewIsWide(view_0) ? get_centered(view_0) : get_atTopEnd(view_0), concernsLegendInfoBubble(view_0));
  view.fbb(p_0, view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (Frame())(view.pc());
  var tmp0_elvis_lhs_6 = view.cbb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view : tmp0_elvis_lhs_6;
  view.ebb(p_6, view_6);
  var tmp_11 = view_6.ibb(view_6.ibb(shownWhen(view_6, VOID, ($this$shownWhen) => $this$shownWhen.baj(concernCards).i1()), sizeConstraints(view_6, VOID, VOID, VOID, VOID, VOID, VOID, times(get_AppDimensions().cg2_1, 0.6))), view_6.hbb(NothingHereSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_7 = new (Frame())(view_6.pc());
  var tmp0_elvis_lhs_7 = view_6.cbb_1;
  var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
  view_6.ebb(p_7, view_7);
  var tmp_12 = get_centered(view_7);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_8 = new (RowOrCol())(view_7.pc());
  var tmp0_elvis_lhs_8 = view_7.cbb_1;
  var p_8 = tmp0_elvis_lhs_8 == null ? view_7 : tmp0_elvis_lhs_8;
  view_7.ebb(p_8, view_8);
  view_8.xbm(true);
  title(view_8, concerns$lambda_6);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_9 = new (TextView())(view_8.pc());
  var tmp0_elvis_lhs_9 = view_8.cbb_1;
  var p_9 = tmp0_elvis_lhs_9 == null ? view_8 : tmp0_elvis_lhs_9;
  view_8.ebb(p_9, view_9);
  view_9.jba(view_9.ob6_1.ybe(BodySemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value = 'When concerns are raised or action is needed they will appear here.';
  var tmp_13 = view_9.tb5_1;
  var tmp_14;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value) === 0) {
    tmp_14 = '\xA0';
  } else {
    tmp_14 = value;
  }
  tmp_13.fbu(tmp_14);
  view_9.bbs(Align_Center_getInstance());
  view_8.fbb(p_9, view_9);
  view_7.fbb(p_8, view_8);
  view_7.jbb(tmp_12, view_8);
  view_6.fbb(p_7, view_7);
  view_6.jbb(tmp_11, view_7);
  var tmp_15 = view_6.ibb(shownWhen(view_6, VOID, ($this$shownWhen) => {
    // Inline function 'com.lightningkite.reactive.core.ReactiveState.ready' call
    var this_0 = $this$shownWhen.daj(concernCards);
    var tmp = _ReactiveState___get_raw__impl__92ipya(this_0);
    return !!(tmp instanceof InternalReactiveNotReady());
  }), sizeConstraints(view_6, VOID, VOID, VOID, VOID, VOID, VOID, times(get_AppDimensions().cg2_1, 0.6)));
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_10 = new (Frame())(view_6.pc());
  var tmp0_elvis_lhs_10 = view_6.cbb_1;
  var p_10 = tmp0_elvis_lhs_10 == null ? view_6 : tmp0_elvis_lhs_10;
  view_6.ebb(p_10, view_10);
  var tmp_16 = get_centered(view_10);
  // Inline function 'com.lightningkite.kiteui.views.direct.activityIndicator' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_11 = new (ActivityIndicator())(view_10.pc());
  var tmp0_elvis_lhs_11 = view_10.cbb_1;
  var p_11 = tmp0_elvis_lhs_11 == null ? view_10 : tmp0_elvis_lhs_11;
  view_10.ebb(p_11, view_11);
  view_10.fbb(p_11, view_11);
  view_10.jbb(tmp_16, view_11);
  view_6.fbb(p_10, view_10);
  view_6.jbb(tmp_15, view_10);
  var tmp_17 = shownWhen(view_6, true, ($this$shownWhen) => {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !$this$shownWhen.baj(concernCards).i1();
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_12 = new (RowOrCol())(view_6.pc());
  var tmp0_elvis_lhs_12 = view_6.cbb_1;
  var p_12 = tmp0_elvis_lhs_12 == null ? view_6 : tmp0_elvis_lhs_12;
  view_6.ebb(p_12, view_12);
  view_12.xbm(true);
  forEachUpdating(view_12, concernCards, 5, ($this$forEachUpdating, info) => {
    var tmp = get_unpadded($this$forEachUpdating);
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (Button())($this$forEachUpdating.pc());
    var tmp0_elvis_lhs = $this$forEachUpdating.cbb_1;
    var p = tmp0_elvis_lhs == null ? $this$forEachUpdating : tmp0_elvis_lhs;
    $this$forEachUpdating.ebb(p, view);
    var tmp_0 = KMutableProperty0();
    var tmp_1 = Button$_get_enabled_$ref_61t7nx(view);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('enabled', 0, tmp_0, tmp_1, Button$_set_enabled_$ref_o8kynz(view));
    reactiveScope(view, ($this$reactiveScope) => {
      var tmp$ret$61 = !($this$reactiveScope.baj(info).ugo_1 == null);
      this_0.set(tmp$ret$61);
      return Unit_instance;
    });
    var tmp_2 = view.hbb(ConcernCard_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_0 = view.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.ebb(p_0, view_0);
    view_0.xbm(true);
    if (get_viewIsWide(view_0)) {
      view_0.jba(view_0.ob6_1.ybe(HalfGap_getInstance()));
    }
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (RowOrCol())(view_0.pc());
    var tmp0_elvis_lhs_1 = view_0.cbb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
    view_0.ebb(p_1, view_1);
    view_1.xbm(false);
    var tmp_3 = get_expanding(view_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
    var breakpoint = get_AppDimensions().gg2_1;
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (RowCollapsingToColumn())(view_1.pc(), listOf(new (Dimension())(breakpoint)));
    var tmp0_elvis_lhs_2 = view_1.cbb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
    view_1.ebb(p_2, view_2);
    if (get_viewIsNarrow(view_2)) {
      view_2.jba(view_2.ob6_1.ybe(HalfGap_getInstance()));
    }
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (RowOrCol())(view_2.pc());
    var tmp0_elvis_lhs_3 = view_2.cbb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
    view_2.ebb(p_3, view_3);
    view_3.xbm(false);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_4 = new (RowOrCol())(view_3.pc());
    var tmp0_elvis_lhs_4 = view_3.cbb_1;
    var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
    view_3.ebb(p_4, view_4);
    view_4.xbm(false);
    view_4.zb8(get_AppDimensions().mg2_1);
    var tmp_4 = get_centered(view_4);
    view_4.jbb(tmp_4, actionIcon(view_4, VOID, ($this$actionIcon) => $this$actionIcon.baj(info).qgo_1));
    var tmp_5 = get_centered(view_4);
    // Inline function 'com.crowpay.views.theming.subTitle' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_5 = new (TextView())(view_4.pc());
    var tmp0_elvis_lhs_5 = view_4.cbb_1;
    var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
    view_4.ebb(p_5, view_5);
    view_5.jba(view_5.ob6_1.ybe(SubtitleSemantic_getInstance()));
    var tmp_6 = KMutableProperty0();
    var tmp_7 = TextView$_get_content_$ref_4pzcwl(view_5);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_1 = getPropertyCallableRef('content', 0, tmp_6, tmp_7, TextView$_set_content_$ref_pketfb(view_5));
    reactiveScope(view_5, ($this$reactiveScope) => {
      var tmp$ret$63 = $this$reactiveScope.baj(info).kgo_1;
      this_1.set(tmp$ret$63);
      return Unit_instance;
    });
    view_4.fbb(p_5, view_5);
    view_4.jbb(tmp_5, view_5);
    view_3.fbb(p_4, view_4);
    var tmp_8 = get_centered(view_3);
    // Inline function 'com.crowpay.views.theming.smallBody' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_6 = new (TextView())(view_3.pc());
    var tmp0_elvis_lhs_6 = view_3.cbb_1;
    var p_6 = tmp0_elvis_lhs_6 == null ? view_3 : tmp0_elvis_lhs_6;
    view_3.ebb(p_6, view_6);
    view_6.jba(view_6.ob6_1.ybe(SmallBodySemantic_getInstance()));
    var tmp_9 = KMutableProperty0();
    var tmp_10 = TextView$_get_content_$ref_4pzcwl_0(view_6);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_2 = getPropertyCallableRef('content', 0, tmp_9, tmp_10, TextView$_set_content_$ref_pketfb_0(view_6));
    reactiveScope(view_6, ($this$reactiveScope) => {
      var tmp$ret$74 = format($this$reactiveScope.baj(info).mgo_1, Formats_getInstance().j8z_1);
      this_2.set(tmp$ret$74);
      return Unit_instance;
    });
    view_3.fbb(p_6, view_6);
    view_3.jbb(tmp_8, view_6);
    view_2.fbb(p_3, view_3);
    var tags = lens(info, concerns$lambda$lambda);
    var tmp_11 = shownWhen(view_2, VOID, ($this$shownWhen) => {
      // Inline function 'kotlin.collections.isNotEmpty' call
      return !$this$shownWhen.baj(tags).i1();
    });
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_7 = new (RowOrCol())(view_2.pc());
    var tmp0_elvis_lhs_7 = view_2.cbb_1;
    var p_7 = tmp0_elvis_lhs_7 == null ? view_2 : tmp0_elvis_lhs_7;
    view_2.ebb(p_7, view_7);
    view_7.xbm(false);
    forEach(view_7, tags, concerns$lambda$lambda_0);
    view_2.fbb(p_7, view_7);
    view_2.jbb(tmp_11, view_7);
    view_1.fbb(p_2, view_2);
    view_1.jbb(tmp_3, view_2);
    var tmp_12 = view_1.ibb(get_atTopEnd(view_1), get_compact(view_1));
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_8 = new (RowOrCol())(view_1.pc());
    var tmp0_elvis_lhs_8 = view_1.cbb_1;
    var p_8 = tmp0_elvis_lhs_8 == null ? view_1 : tmp0_elvis_lhs_8;
    view_1.ebb(p_8, view_8);
    view_8.xbm(true);
    // Inline function 'com.crowpay.views.theming.bodyBold' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_9 = new (TextView())(view_8.pc());
    var tmp0_elvis_lhs_9 = view_8.cbb_1;
    var p_9 = tmp0_elvis_lhs_9 == null ? view_8 : tmp0_elvis_lhs_9;
    view_8.ebb(p_9, view_9);
    view_9.jba(view_9.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
    dynamicTheme(view_9, ($this$dynamicTheme) => DisplayableStateSemantic().mgt($this$dynamicTheme.baj(info).lgo_1));
    var tmp_13 = KMutableProperty0();
    var tmp_14 = TextView$_get_content_$ref_4pzcwl_1(view_9);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_3 = getPropertyCallableRef('content', 0, tmp_13, tmp_14, TextView$_set_content_$ref_pketfb_1(view_9));
    reactiveScope(view_9, ($this$reactiveScope) => {
      var tmp$ret$93 = $this$reactiveScope.baj(info).lgo_1.g90();
      this_3.set(tmp$ret$93);
      return Unit_instance;
    });
    view_8.fbb(p_9, view_9);
    var tmp_15 = get_atEnd(view_8);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_10 = new (RowOrCol())(view_8.pc());
    var tmp0_elvis_lhs_10 = view_8.cbb_1;
    var p_10 = tmp0_elvis_lhs_10 == null ? view_8 : tmp0_elvis_lhs_10;
    view_8.ebb(p_10, view_10);
    view_10.xbm(false);
    var tmp_16 = get_centered(view_10);
    var tmp_17 = view_10.ibb(tmp_16, shownWhen(view_10, VOID, ($this$shownWhen) => !($this$shownWhen.baj(info).sgo_1 == null)));
    view_10.jbb(tmp_17, escalationIcon(view_10, lens(info, concerns$lambda$lambda_1)));
    var tmp_18 = get_centered(view_10);
    var tmp_19 = view_10.ibb(tmp_18, shownWhen(view_10, VOID, ($this$shownWhen) => !($this$shownWhen.baj(info).rgo_1 == null)));
    view_10.jbb(tmp_19, timerRunningIconRaw(view_10, lens(info, concerns$lambda$lambda_2)));
    view_8.fbb(p_10, view_10);
    view_8.jbb(tmp_15, view_10);
    view_1.fbb(p_8, view_8);
    view_1.jbb(tmp_12, view_8);
    view_0.fbb(p_1, view_1);
    var tmp_20 = get_compact(view_0);
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_11 = new (RowOrCol())(view_0.pc());
    var tmp0_elvis_lhs_11 = view_0.cbb_1;
    var p_11 = tmp0_elvis_lhs_11 == null ? view_0 : tmp0_elvis_lhs_11;
    view_0.ebb(p_11, view_11);
    view_11.xbm(true);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_12 = new (RowOrCol())(view_11.pc());
    var tmp0_elvis_lhs_12 = view_11.cbb_1;
    var p_12 = tmp0_elvis_lhs_12 == null ? view_11 : tmp0_elvis_lhs_12;
    view_11.ebb(p_12, view_12);
    view_12.xbm(false);
    var tmp_21 = get_atBottom(view_12);
    // Inline function 'com.crowpay.views.theming.bodyBold' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_13 = new (TextView())(view_12.pc());
    var tmp0_elvis_lhs_13 = view_12.cbb_1;
    var p_13 = tmp0_elvis_lhs_13 == null ? view_12 : tmp0_elvis_lhs_13;
    view_12.ebb(p_13, view_13);
    view_13.jba(view_13.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
    var tmp_22 = KMutableProperty0();
    var tmp_23 = TextView$_get_content_$ref_4pzcwl_2(view_13);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_4 = getPropertyCallableRef('content', 0, tmp_22, tmp_23, TextView$_set_content_$ref_pketfb_2(view_13));
    reactiveScope(view_13, ($this$reactiveScope) => {
      var tmp$ret$112 = $this$reactiveScope.baj(info).ngo_1.g94() ? $this$reactiveScope.baj(_this__u8e3s4.wgk()).f5c_1 : $this$reactiveScope.baj(_this__u8e3s4.fgl()).x5i_1;
      this_4.set(tmp$ret$112);
      return Unit_instance;
    });
    view_12.fbb(p_13, view_13);
    view_12.jbb(tmp_21, view_13);
    var tmp_24 = get_atBottom(view_12);
    // Inline function 'com.crowpay.views.theming.smallBody' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_14 = new (TextView())(view_12.pc());
    var tmp0_elvis_lhs_14 = view_12.cbb_1;
    var p_14 = tmp0_elvis_lhs_14 == null ? view_12 : tmp0_elvis_lhs_14;
    view_12.ebb(p_14, view_14);
    view_14.jba(view_14.ob6_1.ybe(SmallBodySemantic_getInstance()));
    var tmp_25 = KMutableProperty0();
    var tmp_26 = TextView$_get_content_$ref_4pzcwl_3(view_14);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_5 = getPropertyCallableRef('content', 0, tmp_25, tmp_26, TextView$_set_content_$ref_pketfb_3(view_14));
    reactiveScope(view_14, ($this$reactiveScope) => {
      var tmp$ret$119 = format($this$reactiveScope.baj(info).ngo_1.i94(), Formats_getInstance().k8z_1);
      this_5.set(tmp$ret$119);
      return Unit_instance;
    });
    view_12.fbb(p_14, view_14);
    view_12.jbb(tmp_24, view_14);
    view_11.fbb(p_12, view_12);
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_15 = new (RowOrCol())(view_11.pc());
    var tmp0_elvis_lhs_15 = view_11.cbb_1;
    var p_15 = tmp0_elvis_lhs_15 == null ? view_11 : tmp0_elvis_lhs_15;
    view_11.ebb(p_15, view_15);
    view_15.xbm(true);
    dynamicTheme(view_15, ($this$dynamicTheme) => MessageSemantic().qgt($this$dynamicTheme.baj(info).ngo_1.h94().equals($this$dynamicTheme.baj(get_session()).efv_1)));
    // Inline function 'com.crowpay.views.theming.bodyBold' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_16 = new (TextView())(view_15.pc());
    var tmp0_elvis_lhs_16 = view_15.cbb_1;
    var p_16 = tmp0_elvis_lhs_16 == null ? view_15 : tmp0_elvis_lhs_16;
    view_15.ebb(p_16, view_16);
    view_16.jba(view_16.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
    var tmp_27 = KMutableProperty0();
    var tmp_28 = TextView$_get_content_$ref_4pzcwl_4(view_16);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_6 = getPropertyCallableRef('content', 0, tmp_27, tmp_28, TextView$_set_content_$ref_pketfb_4(view_16));
    reactiveScope(view_16, ($this$reactiveScope) => {
      var tmp$ret$130 = '"' + $this$reactiveScope.baj(info).ogo_1 + '"';
      this_6.set(tmp$ret$130);
      return Unit_instance;
    });
    view_15.fbb(p_16, view_16);
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_17 = new (TextView())(view_15.pc());
    var tmp0_elvis_lhs_17 = view_15.cbb_1;
    var p_17 = tmp0_elvis_lhs_17 == null ? view_15 : tmp0_elvis_lhs_17;
    view_15.ebb(p_17, view_17);
    view_17.jba(view_17.ob6_1.ybe(BodySemantic_getInstance()));
    var tmp_29 = KMutableProperty0();
    var tmp_30 = TextView$_get_shown_$ref_kipsub(view_17);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_7 = getPropertyCallableRef('shown', 0, tmp_29, tmp_30, TextView$_set_shown_$ref_l7jsq9(view_17));
    reactiveScope(view_17, ($this$reactiveScope) => {
      // Inline function 'kotlin.text.isNotBlank' call
      var this_0 = $this$reactiveScope.baj(info).ngo_1.j();
      var tmp$ret$138 = !isBlank(this_0);
      this_7.set(tmp$ret$138);
      return Unit_instance;
    });
    var tmp_31 = KMutableProperty0();
    var tmp_32 = TextView$_get_content_$ref_4pzcwl_5(view_17);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_8 = getPropertyCallableRef('content', 0, tmp_31, tmp_32, TextView$_set_content_$ref_pketfb_5(view_17));
    reactiveScope(view_17, ($this$reactiveScope) => {
      var tmp$ret$140 = $this$reactiveScope.baj(info).ngo_1.j();
      this_8.set(tmp$ret$140);
      return Unit_instance;
    });
    view_15.fbb(p_17, view_17);
    view_11.fbb(p_15, view_15);
    view_0.fbb(p_11, view_11);
    view_0.jbb(tmp_20, view_11);
    view.fbb(p_0, view_0);
    view.jbb(tmp_2, view_0);
    var tmp_33 = view.hbb(OverlayHover_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_18 = new (Frame())(view.pc());
    var tmp0_elvis_lhs_18 = view.cbb_1;
    var p_18 = tmp0_elvis_lhs_18 == null ? view : tmp0_elvis_lhs_18;
    view.ebb(p_18, view_18);
    view.fbb(p_18, view_18);
    view.jbb(tmp_33, view_18);
    onClick(view, 'View Concern', VOID, concerns$lambda$slambda_0(info, view));
    $this$forEachUpdating.fbb(p, view);
    $this$forEachUpdating.jbb(tmp, view);
    return Unit_instance;
  });
  view_6.fbb(p_12, view_12);
  view_6.jbb(tmp_17, view_12);
  view.fbb(p_6, view_6);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_13 = new (Space())(view.pc(), 2.0);
  var tmp0_elvis_lhs_13 = view.cbb_1;
  var p_13 = tmp0_elvis_lhs_13 == null ? view : tmp0_elvis_lhs_13;
  view.ebb(p_13, view_13);
  view.fbb(p_13, view_13);
  writer.fbb(p, view);
  return view;
}
function concerns$_anonymous_$_anonymous_$getCards_7kfjf0(_this__u8e3s4, cards, lineItemMessages, $this_remember, $this_concerns, lineTimers, lineComments) {
  // Inline function 'kotlin.collections.mapNotNullTo' call
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = _this__u8e3s4.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var tmp$ret$0;
    $l$block_0: {
      var tmp0_elvis_lhs = lineItemMessages.p3(element.kf9_1);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$0 = null;
        break $l$block_0;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var messages = tmp;
      if (messages.i1()) {
        tmp$ret$0 = null;
        break $l$block_0;
      }
      var perms = $this_remember.baj($this_concerns.mgf()).p3(element.kf9_1);
      var tmp1_safe_receiver = $this_remember.baj(lineTimers).p3(element.kf9_1);
      var tmp_0;
      if (tmp1_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.collections.find' call
        var tmp$ret$2;
        $l$block_1: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var _iterator__ex2g4s_0 = tmp1_safe_receiver.m1();
          while (_iterator__ex2g4s_0.n1()) {
            var element_0 = _iterator__ex2g4s_0.o1();
            if (element_0.z7t_1.equals(TimerAction_CompleteLineItem_getInstance()) && element_0.c7u_1 == null) {
              tmp$ret$2 = element_0;
              break $l$block_1;
            }
          }
          tmp$ret$2 = null;
        }
        tmp_0 = tmp$ret$2;
      }
      var timer = tmp_0;
      var tmp2_elvis_lhs = lastOrNull(messages);
      var tmp_1;
      if (tmp2_elvis_lhs == null) {
        throw NotFound().nfx(getKClass(LineItemCompletionMessage()), null);
      } else {
        tmp_1 = tmp2_elvis_lhs;
      }
      var last = tmp_1;
      var tmp11_type = Type_LineItem_getInstance();
      var tmp12_id = element.kf9_1;
      var tmp13_title = element.lf9_1;
      var tmp14_state = displayState(element.kfy());
      var tmp15_timestamp = first(messages).g6h_1;
      var tmp_2 = last.f8w();
      var tmp4_safe_receiver = perms == null ? null : perms.o8x_1;
      var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.j8x(last.g6h_1);
      var tmp16_messageName = tmp_2.z8y(tmp5_elvis_lhs == null ? LineItemHistory().w8w(element.hf9_1, emptySet(), null) : tmp5_elvis_lhs);
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList().w();
      var _iterator__ex2g4s_1 = lineComments.m1();
      while (_iterator__ex2g4s_1.n1()) {
        var element_1 = _iterator__ex2g4s_1.o1();
        if (element_1.s5d_1.equals(element.kf9_1)) {
          destination.v(element_1);
        }
      }
      var tmp17_readBy = readByIntersection(plus(messages, destination));
      var tmp18_actionIcon = perms == null ? null : requiresAction(perms, true);
      var tmp19_escalationLevel = perms == null ? null : perms.n8w();
      var tmp_3;
      if (equals(perms == null ? null : perms.n8w(), EscalationLevel_Disputed_getInstance())) {
        tmp_3 = TimerState_Cancelled_getInstance();
      } else {
        if (timer == null) {
          tmp_3 = null;
        } else {
          if (timer.u98()) {
            tmp_3 = TimerState_Paused_getInstance();
          } else {
            tmp_3 = TimerState_Running_getInstance();
          }
        }
      }
      var tmp20_timerState = tmp_3;
      var tmp10_elvis_lhs = perms == null ? null : perms.p8x_1;
      var tmp21_tags = tmp10_elvis_lhs == null ? emptySet() : tmp10_elvis_lhs;
      tmp$ret$0 = ConcernCardInfo().zgo(tmp11_type, tmp12_id, tmp13_title, tmp14_state, tmp15_timestamp, last, tmp16_messageName, tmp17_readBy, tmp18_actionIcon, tmp20_timerState, tmp19_escalationLevel, tmp21_tags, concerns$_anonymous_$_anonymous_$getCards$slambda_5cku3m_0(element, $this_remember, $this_concerns));
    }
    var tmp0_safe_receiver = tmp$ret$0;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      cards.v(tmp0_safe_receiver);
    }
  }
  return cards;
}
function concerns$_anonymous_$_anonymous_$getCards$0_r9bqu0(_this__u8e3s4, cards, incidentMessages, $this_remember, $this_concerns, incidentComments) {
  // Inline function 'kotlin.collections.mapNotNullTo' call
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = _this__u8e3s4.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var tmp$ret$0;
    $l$block: {
      var tmp0_elvis_lhs = incidentMessages.p3(element.d63_1);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$0 = null;
        break $l$block;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var messages = tmp;
      var perms = $this_remember.baj($this_concerns.rgt()).p3(element.d63_1);
      var tmp1_elvis_lhs = lastOrNull(messages);
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        throw NotFound().nfx(getKClass(IncidentMessage()), null);
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      var last = tmp_0;
      var tmp_1 = Type_Incident_getInstance();
      var tmp_2 = displayState_0(element.k63_1);
      var tmp_3 = last.f94();
      var tmp3_safe_receiver = perms == null ? null : perms.n9d_1;
      var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.j8x(last.e68_1);
      var tmp_4 = tmp_3.z9e(tmp4_elvis_lhs == null ? IncidentHistory().m9e(element, messages) : tmp4_elvis_lhs);
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList().w();
      var _iterator__ex2g4s_0 = incidentComments.m1();
      while (_iterator__ex2g4s_0.n1()) {
        var element_0 = _iterator__ex2g4s_0.o1();
        if (element_0.v65_1.equals(element.d63_1)) {
          destination.v(element_0);
        }
      }
      var tmp_5 = readByIntersection(plus(messages, destination));
      var tmp_6 = perms == null ? null : requiresAction(perms, true);
      var tmp_7 = perms == null ? null : perms.n8w();
      tmp$ret$0 = ConcernCardInfo().zgo(tmp_1, element.d63_1, element.j63_1.e9f_1, tmp_2, element.f63_1.q54_1, last, tmp_4, tmp_5, tmp_6, VOID, tmp_7, VOID, concerns$_anonymous_$_anonymous_$getCards$0$slambda_4p09v2_0($this_remember, $this_concerns, element, messages));
    }
    var tmp0_safe_receiver = tmp$ret$0;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      cards.v(tmp0_safe_receiver);
    }
  }
  return cards;
}
function concerns$_anonymous_$_anonymous_$getCards$1_r9bqu1(_this__u8e3s4, cards, payApps, lineItems, $this_concerns) {
  // Inline function 'kotlin.collections.groupBy' call
  // Inline function 'kotlin.collections.groupByTo' call
  var destination = LinkedHashMap().f6();
  var _iterator__ex2g4s = _this__u8e3s4.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var key = element.r6v_1;
    // Inline function 'kotlin.collections.getOrPut' call
    var value = destination.p3(key);
    var tmp;
    if (value == null) {
      var answer = ArrayList().w();
      destination.s3(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var list = tmp;
    list.v(element);
  }
  // Inline function 'kotlin.collections.mapNotNullTo' call
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_0 = destination.d2().m1();
  while (_iterator__ex2g4s_0.n1()) {
    var element_0 = _iterator__ex2g4s_0.o1();
    var tmp$ret$8;
    $l$block_1: {
      // Inline function 'kotlin.collections.component1' call
      var payApp = element_0.e2();
      // Inline function 'kotlin.collections.component2' call
      var draws = element_0.f2();
      var tmp0_elvis_lhs = payApps.p3(payApp);
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$8 = null;
        break $l$block_1;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var payApp_0 = tmp_0;
      var tmp$ret$9;
      $l$block_0: {
        // Inline function 'kotlin.collections.maxBy' call
        var iterator = draws.m1();
        if (!iterator.n1())
          throw NoSuchElementException().y1();
        var maxElem = iterator.o1();
        if (!iterator.n1()) {
          tmp$ret$9 = maxElem;
          break $l$block_0;
        }
        var tmp0_elvis_lhs_0 = maxElem.l96();
        var maxValue = tmp0_elvis_lhs_0 == null ? Companion_getInstance_0().e1m_1 : tmp0_elvis_lhs_0;
        do {
          var e = iterator.o1();
          var tmp0_elvis_lhs_1 = e.l96();
          var v = tmp0_elvis_lhs_1 == null ? Companion_getInstance_0().e1m_1 : tmp0_elvis_lhs_1;
          if (compareTo(maxValue, v) < 0) {
            maxElem = e;
            maxValue = v;
          }
        }
         while (iterator.n1());
        tmp$ret$9 = maxElem;
      }
      var mostRecent = tmp$ret$9;
      var tmp1_elvis_lhs = lineItems.p3(mostRecent.s6v_1);
      var tmp_1;
      if (tmp1_elvis_lhs == null) {
        tmp$ret$8 = null;
        break $l$block_1;
      } else {
        tmp_1 = tmp1_elvis_lhs;
      }
      var line = tmp_1;
      var tmp_2 = draws.p1() > 1;
      tmp$ret$8 = ConcernCardInfo().cgp(mostRecent, line, payApp_0, tmp_2, concerns$_anonymous_$_anonymous_$getCards$1$slambda_p73qxd_0(payApp_0, draws, lineItems, $this_concerns));
    }
    var tmp0_safe_receiver = tmp$ret$8;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      cards.v(tmp0_safe_receiver);
    }
  }
  return cards;
}
function concerns$_anonymous_$_anonymous_$getCards$2_r9bqu2(_this__u8e3s4, cards, $this_concerns) {
  // Inline function 'kotlin.collections.groupBy' call
  // Inline function 'kotlin.collections.groupByTo' call
  var destination = LinkedHashMap().f6();
  var _iterator__ex2g4s = _this__u8e3s4.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var key = element.q94();
    // Inline function 'kotlin.collections.getOrPut' call
    var value = destination.p3(key);
    var tmp;
    if (value == null) {
      var answer = ArrayList().w();
      destination.s3(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var list = tmp;
    list.v(element);
  }
  // Inline function 'kotlin.collections.mapNotNullTo' call
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_0 = destination.d2().m1();
  while (_iterator__ex2g4s_0.n1()) {
    var element_0 = _iterator__ex2g4s_0.o1();
    // Inline function 'kotlin.collections.component1' call
    var change = element_0.e2();
    // Inline function 'kotlin.collections.component2' call
    var items = element_0.f2();
    var tmp$ret$8;
    $l$block: {
      // Inline function 'kotlin.collections.maxBy' call
      var iterator = items.m1();
      if (!iterator.n1())
        throw NoSuchElementException().y1();
      var maxElem = iterator.o1();
      if (!iterator.n1()) {
        tmp$ret$8 = maxElem;
        break $l$block;
      }
      var tmp0_elvis_lhs = maxElem.y94();
      var maxValue = tmp0_elvis_lhs == null ? Companion_getInstance_0().e1m_1 : tmp0_elvis_lhs;
      do {
        var e = iterator.o1();
        var tmp0_elvis_lhs_0 = e.y94();
        var v = tmp0_elvis_lhs_0 == null ? Companion_getInstance_0().e1m_1 : tmp0_elvis_lhs_0;
        if (compareTo(maxValue, v) < 0) {
          maxElem = e;
          maxValue = v;
        }
      }
       while (iterator.n1());
      tmp$ret$8 = maxElem;
    }
    var mostRecent = tmp$ret$8;
    var tmp_0 = items.p1() > 1;
    var tmp0_safe_receiver = ConcernCardInfo().kgp(mostRecent, tmp_0, concerns$_anonymous_$_anonymous_$getCards$2$slambda_fxwa9c_0($this_concerns, change, items));
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      cards.v(tmp0_safe_receiver);
    }
  }
  return cards;
}
function concerns$lambda(it) {
  // Inline function 'kotlin.collections.groupBy' call
  // Inline function 'kotlin.collections.groupByTo' call
  var destination = LinkedHashMap().f6();
  var _iterator__ex2g4s = it.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var key = element.t7t_1;
    // Inline function 'kotlin.collections.getOrPut' call
    var value = destination.p3(key);
    var tmp;
    if (value == null) {
      var answer = ArrayList().w();
      destination.s3(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var list = tmp;
    list.v(element);
  }
  return filterNullKeys(destination);
}
function concerns$lambda_0(it) {
  // Inline function 'kotlin.collections.groupBy' call
  // Inline function 'kotlin.collections.groupByTo' call
  var destination = LinkedHashMap().f6();
  var _iterator__ex2g4s = it.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var key = element.a6h_1;
    // Inline function 'kotlin.collections.getOrPut' call
    var value = destination.p3(key);
    var tmp;
    if (value == null) {
      var answer = ArrayList().w();
      destination.s3(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var list = tmp;
    list.v(element);
  }
  return destination;
}
function concerns$lambda_1(it) {
  // Inline function 'kotlin.collections.groupBy' call
  // Inline function 'kotlin.collections.groupByTo' call
  var destination = LinkedHashMap().f6();
  var _iterator__ex2g4s = it.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var key = element.x67_1;
    // Inline function 'kotlin.collections.getOrPut' call
    var value = destination.p3(key);
    var tmp;
    if (value == null) {
      var answer = ArrayList().w();
      destination.s3(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var list = tmp;
    list.v(element);
  }
  return destination;
}
function concerns$lambda_2(it) {
  // Inline function 'kotlin.collections.associateBy' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(it, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap().fc(capacity);
  var _iterator__ex2g4s = it.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var tmp$ret$0 = element.i6y_1;
    destination.s3(tmp$ret$0, element);
  }
  return destination;
}
function concerns$lambda_3(it) {
  // Inline function 'kotlin.collections.associateBy' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(it, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap().fc(capacity);
  var _iterator__ex2g4s = it.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var tmp$ret$0 = element.kf9_1;
    destination.s3(tmp$ret$0, element);
  }
  return destination;
}
function concerns$lambda_4($this$dismissableBanner) {
  return $this$dismissableBanner.jbb(notificationBar($this$dismissableBanner, AppColors_getInstance().jfz_1), body($this$dismissableBanner, 'Concerns of contractor work performance or service are processed here. Work concerns originate from sign off requests by marking the item as Not Ready. Service concerns originate from the "Report Incident" button. \n\nBoth work or service concerns can escalate to Issue and then Dispute statuses, with multiple opportunities to correct, before either party has the option to lock the project.  \n\nReporting an Incident alerts contractor for documentation purposes, or can be raised to an Issue, which formally notices the contractor and requires a response.  '));
}
function concerns$lambda_5(it) {
  return it.a4_1;
}
function *_generator_invoke__zhh2q8($this, $completion) {
  var tmp = get_dialogStack();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.sgt_1.jfy();
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp$ret$0 = tmp_0;
  tmp.ebw(new (FileIncidentConfirmation())(tmp$ret$0, $this.sgt_1.rgj()));
  return Unit_instance;
}
var concerns$slambdaClass;
function concerns$slambda() {
  if (concerns$slambdaClass === VOID) {
    class $ {
      constructor($this_concerns) {
        this.sgt_1 = $this_concerns;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    concerns$slambdaClass = $;
  }
  return concerns$slambdaClass;
}
function concerns$slambda_0($this_concerns) {
  var i = new (concerns$slambda())($this_concerns);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function concerns$lambda_6($this$title) {
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value = 'Nothing Yet';
  var tmp = $this$title.tb5_1;
  var tmp_0;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value) === 0) {
    tmp_0 = '\xA0';
  } else {
    tmp_0 = value;
  }
  tmp.fbu(tmp_0);
  $this$title.bbs(Align_Center_getInstance());
  return Unit_instance;
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.tgt_1 = function_0;
      }
      wi(a, b) {
        return this.tgt_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.tgt_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.tb5_1.zb3_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.ib7_1.disabled = value;
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function concerns$lambda$lambda(i) {
  // Inline function 'kotlin.collections.sortedBy' call
  var this_0 = i.tgo_1;
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp = concerns$lambda$lambda$lambda;
  var tmp$ret$0 = new (sam$kotlin_Comparator$0())(tmp);
  return sortedWith(this_0, tmp$ret$0);
}
function concerns$lambda$lambda$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.i90();
  var tmp$ret$1 = b.i90();
  return compareValues(tmp, tmp$ret$1);
}
function concerns$lambda$lambda_0($this$forEach, tag) {
  $this$forEach.jbb($this$forEach.ibb(get_centered($this$forEach), $this$forEach.hbb(StateTagSemantic().wgt(tag))), body($this$forEach, tag.g90()));
  return Unit_instance;
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function concerns$lambda$lambda_1(it) {
  return it.sgo_1;
}
function concerns$lambda$lambda_2(it) {
  var tmp0_elvis_lhs = it.rgo_1;
  return tmp0_elvis_lhs == null ? TimerState_Paused_getInstance() : tmp0_elvis_lhs;
}
function TextView$_get_content_$ref_4pzcwl_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_3(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_3(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_4(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_4(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_shown_$ref_kipsub(p0) {
  return () => p0.wb8();
}
function TextView$_set_shown_$ref_l7jsq9(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_5(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_5(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.xgt_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_safe_receiver = tmp.ugo_1;
  var tmp_0;
  if (tmp0_safe_receiver == null) {
    tmp_0 = null;
  } else {
    var tmp_1 = tmp0_safe_receiver($completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = tmp_1;
  }
  var tmp1_safe_receiver = tmp_0;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var this_1 = $this.ygt_1;
    navigateOrDialog(this_1, tmp1_safe_receiver);
  }
  return Unit_instance;
}
var concerns$lambda$slambdaClass;
function concerns$lambda$slambda() {
  if (concerns$lambda$slambdaClass === VOID) {
    class $ {
      constructor($info, $$this$button) {
        this.xgt_1 = $info;
        this.ygt_1 = $$this$button;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    concerns$lambda$slambdaClass = $;
  }
  return concerns$lambda$slambdaClass;
}
function concerns$lambda$slambda_0($info, $$this$button) {
  var i = new (concerns$lambda$slambda())($info, $$this$button);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  var tmp = Companion_instance.cgu($this.zgt_1, $this.agu_1.baj($this.bgu_1.jfy()), $this.bgu_1.rgj(), VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.apply' call
  var this_0 = tmp;
  if (isFinal($this.zgt_1.kfy())) {
    set_value(this_0.hgv_1, true);
  }
  return this_0;
}
var concerns$_anonymous_$_anonymous_$getCards$slambda_5cku3mClass;
function concerns$_anonymous_$_anonymous_$getCards$slambda_5cku3m() {
  if (concerns$_anonymous_$_anonymous_$getCards$slambda_5cku3mClass === VOID) {
    class $ {
      constructor($lineItem, $$this_remember, $$this_concerns) {
        this.zgt_1 = $lineItem;
        this.agu_1 = $$this_remember;
        this.bgu_1 = $$this_concerns;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    concerns$_anonymous_$_anonymous_$getCards$slambda_5cku3mClass = $;
  }
  return concerns$_anonymous_$_anonymous_$getCards$slambda_5cku3mClass;
}
function concerns$_anonymous_$_anonymous_$getCards$slambda_5cku3m_0($lineItem, $$this_remember, $$this_concerns) {
  var i = new (concerns$_anonymous_$_anonymous_$getCards$slambda_5cku3m())($lineItem, $$this_remember, $$this_concerns);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var concerns$_anonymous_$_anonymous_$getCards$0$slambda_4p09v2Class;
function concerns$_anonymous_$_anonymous_$getCards$0$slambda_4p09v2() {
  if (concerns$_anonymous_$_anonymous_$getCards$0$slambda_4p09v2Class === VOID) {
    class $ {
      constructor($$this_remember, $$this_concerns, $incident, $messages) {
        this.kgv_1 = $$this_remember;
        this.lgv_1 = $$this_concerns;
        this.mgv_1 = $incident;
        this.ngv_1 = $messages;
      }
      sao($completion) {
        return Companion_instance_0.vgq(this.kgv_1.baj(this.lgv_1.jfy()), this.mgv_1, this.ngv_1, this.lgv_1.rgj(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    concerns$_anonymous_$_anonymous_$getCards$0$slambda_4p09v2Class = $;
  }
  return concerns$_anonymous_$_anonymous_$getCards$0$slambda_4p09v2Class;
}
function concerns$_anonymous_$_anonymous_$getCards$0$slambda_4p09v2_0($$this_remember, $$this_concerns, $incident, $messages) {
  var i = new (concerns$_anonymous_$_anonymous_$getCards$0$slambda_4p09v2())($$this_remember, $$this_concerns, $incident, $messages);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_2($this, $completion) {
  var tmp = awaitSuspending($this.rgv_1.wgk(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = awaitSuspending($this.rgv_1.fgl(), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return new (DrawWaitedDetails())($this.ogv_1, $this.pgv_1, $this.qgv_1, tmp.f5c_1, tmp_0.x5i_1);
}
var concerns$_anonymous_$_anonymous_$getCards$1$slambda_p73qxdClass;
function concerns$_anonymous_$_anonymous_$getCards$1$slambda_p73qxd() {
  if (concerns$_anonymous_$_anonymous_$getCards$1$slambda_p73qxdClass === VOID) {
    class $ {
      constructor($payApp, $draws, $lineItems, $$this_concerns) {
        this.ogv_1 = $payApp;
        this.pgv_1 = $draws;
        this.qgv_1 = $lineItems;
        this.rgv_1 = $$this_concerns;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    concerns$_anonymous_$_anonymous_$getCards$1$slambda_p73qxdClass = $;
  }
  return concerns$_anonymous_$_anonymous_$getCards$1$slambda_p73qxdClass;
}
function concerns$_anonymous_$_anonymous_$getCards$1$slambda_p73qxd_0($payApp, $draws, $lineItems, $$this_concerns) {
  var i = new (concerns$_anonymous_$_anonymous_$getCards$1$slambda_p73qxd())($payApp, $draws, $lineItems, $$this_concerns);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_3($this, $completion) {
  var tmp = awaitSuspending($this.sgv_1.vgv(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.find' call
  var tmp0 = tmp;
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (element.q57_1.equals($this.tgv_1)) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$1;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    throw NotFound().nfx(getKClass(ChangeRequest()), null);
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var changeRequest = tmp_0;
  var tmp_1 = awaitSuspending($this.sgv_1.wgk(), $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp_2 = awaitSuspending($this.sgv_1.fgl(), $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return new (ChangesRejectedDetails())(changeRequest, $this.ugv_1, tmp_1.f5c_1, tmp_2.x5i_1);
}
var concerns$_anonymous_$_anonymous_$getCards$2$slambda_fxwa9cClass;
function concerns$_anonymous_$_anonymous_$getCards$2$slambda_fxwa9c() {
  if (concerns$_anonymous_$_anonymous_$getCards$2$slambda_fxwa9cClass === VOID) {
    class $ {
      constructor($$this_concerns, $change, $items) {
        this.sgv_1 = $$this_concerns;
        this.tgv_1 = $change;
        this.ugv_1 = $items;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    concerns$_anonymous_$_anonymous_$getCards$2$slambda_fxwa9cClass = $;
  }
  return concerns$_anonymous_$_anonymous_$getCards$2$slambda_fxwa9cClass;
}
function concerns$_anonymous_$_anonymous_$getCards$2$slambda_fxwa9c_0($$this_concerns, $change, $items) {
  var i = new (concerns$_anonymous_$_anonymous_$getCards$2$slambda_fxwa9c())($$this_concerns, $change, $items);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function ConcernSection_All_getInstance() {
  ConcernSection_initEntries();
  return ConcernSection_All_instance;
}
function ConcernSection_Work_getInstance() {
  ConcernSection_initEntries();
  return ConcernSection_Work_instance;
}
function ConcernSection_Service_getInstance() {
  ConcernSection_initEntries();
  return ConcernSection_Service_instance;
}
function ConcernSection_Draws_getInstance() {
  ConcernSection_initEntries();
  return ConcernSection_Draws_instance;
}
function ConcernSection_Changes_getInstance() {
  ConcernSection_initEntries();
  return ConcernSection_Changes_instance;
}
//region block: exports
export {
  concerns as concerns11krqc6dzu1f1,
};
//endregion

//# sourceMappingURL=concerns.mjs.map
